import { getApiCall } from "./tokenService";
import { SettingsMain } from "../models/settings/settingsMain";

export const getSettingsMain = (): Promise<SettingsMain> => {
    return getApiCall<SettingsMain>("api/settings/settingsmain", SettingsMain);
};